import * as React from 'react'

const style = require('./Carousel.css')

interface Props {
  children: React.ReactNode;
}

const Header = ({ children }: Props): React.ReactNode => (
  <div className={style.header}>
    {children}
  </div>
)

const Cards = ({ children }: Props): React.ReactNode => (
  <div className={style.cards}>
    {children}
  </div>
)

export class Carousel extends React.Component<Props> {
  static Header = Header
  static Cards = Cards

  render() {
    return (
      <div className={style.container}>
        {this.props.children}
      </div>
    )
  }
}
